import {createAxiosInstance} from './base.api'

const worklogApi = createAxiosInstance('worklogs')

export const getWorklog = (id, errorMethod) => createAxiosInstance(worklogApi).get(`/${id}`)
.catch(error => errorMethod(error))

export const updateWorklog = (id, worklog, successMethod, errorMethod) => createAxiosInstance(worklogApi).put(`/${id}`, worklog)
.then(response => successMethod(response))
.catch(error => errorMethod(error))
